import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Division Master', screenId: '4.3.1', module: 'Procurement', apiPath: 'division', screenName: 'DivisionMaster', idField: 'DivUId', nameField: 'DivName',
  gridColumns: [{ field: 'DivUId', header: 'Division ID' }, { field: 'DivName', header: 'Division Name' }],
  formFields: [{ field: 'DivUId', label: 'Division Id', disabled: true }, { field: 'DivName', label: 'Division Name', required: true }]
});
